import './globals.css';
import './participant-system.css';
import HomePage from './page';

/** Participant portal screens, copied from participant-portal and scoped to this route. */
export default function FieldworkParticipant() {
  return (
    <div className="fieldwork-root">
      <HomePage />
    </div>
  );
}
